import { cn } from "@/lib/utils";

// Flags ship with the app (one small SVG each, fetched only when shown), so they never depend on an outside site.
const FLAGS = import.meta.glob<string>("../../../node_modules/country-flag-icons/3x2/*.svg", { query: "?no-inline", import: "default", eager: true });
const byCode: Record<string, string> = Object.fromEntries(
  Object.entries(FLAGS).map(([path, url]) => [path.slice(path.lastIndexOf("/") + 1, -4), url]),
);

/** A country's flag (ISO alpha-2), or a neutral badge with the code when there is no flag for it. */
export default function Flag({ code, className }: { code?: string | null; className?: string }) {
  const cc = (code ?? "").toUpperCase();
  const src = byCode[cc];
  if (!src) {
    return <span className={cn("inline-flex items-center justify-center rounded bg-gray-100 text-[9px] font-semibold text-gray-500", className)}>{cc || "—"}</span>;
  }
  return <img src={src} alt="" loading="lazy" className={cn("rounded-[3px] object-cover shadow-[0_0_0_1px_rgba(0,0,0,0.06)]", className)} />;
}

let currencyNames: Intl.DisplayNames | null = null;
/** "UGX" → "Ugandan Shilling", in the viewer's language. */
export const currencyName = (code: string) => {
  try {
    currencyNames ??= new Intl.DisplayNames(undefined, { type: "currency" });
    return currencyNames.of(code) ?? code;
  } catch {
    return code;
  }
};
